import { MembershipOrderItemSerializable } from './membership-order-item-serializable';

export class GroupMembershipOrderItemSerializable extends MembershipOrderItemSerializable {
  slotsCount: number = null;
  sfdcOpportunityId: string = null;
  contractCommencementDate: string = null;
  beneficiaries: Array<number> = [];
}
